import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';

export const trackCalltrackingClick = (isChecked, amount) => {
  const state = isChecked ? 'on' : 'off';
  const label = amount > 0 ? 'paid' : 'free';

  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: `calltracking_${state}`,
    label,
  });
};
